import {
  ARTISANS_FAIL,
  ARTISANS_LOADING,
  GET_ARTISANS,
} from '../Actions/actionTypes';

const initialState = {
  artisans: [],
  loading: false,
  error: null,
};

const artisanReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_ARTISANS:
      return { ...state, artisans: action.payload, error: null };
    case ARTISANS_LOADING:
      return { ...state, loading: action.payload };
    case ARTISANS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default artisanReducers;
